/* @flow */

import * as React from 'react';
import { useIntl } from 'react-intl';
import { useField } from 'formik';

import styles from '../FormBuilder.style';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';

import { getFieldTitle } from 'src/shared/app/base/component/data-entry/form-builder/utils/FormBuilderUtils';

import FormikCheckbox from 'src/shared/app/base/component/data-entry/form/FormikCheckbox';
import FormBuilderField from '../FormBuilderField';

import type { Field } from 'src/shared/app/base/component/data-entry/form-builder/type/formBuilderTypes';

const useStyles = createUseThemeStyles(styles);

const FormBuilderCheckbox = ({
  field,
  name,
  parentName,
  'aria-describedby': ariaDescribedby,
}: Field): React.Node => {
  const classes = useStyles();
  const [formikField] = useField(name);
  const intl = useIntl();
  return (
    <div>
      <FormikCheckbox
        key={name}
        text={getFieldTitle(field, intl)}
        name={name}
        aria-describedby={ariaDescribedby}
      />
      {formikField.value && field.more && (
        <div className={classes.more}>
          {field.more?.map((more) => (
            <FormBuilderField
              key={more.key}
              field={more}
              type={more.field_type}
              name={parentName ? `${parentName}.${more.key}` : more.key}
              // For nested form
              // name={`${name}_children.${more.key}`}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default React.memo<Field>(FormBuilderCheckbox);
